import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import CustomButton from "../../../components/button";
import { toast } from "react-toastify";
// import KeywordSkeleton from "../component/skeletons/keywordSkeleton";
// import InputSkeleton from "../component/skeletons/InputSkeleton";

export default function SubTopics(props) {

    const { handleNext, details, handleChange, topics, setTopics, topicsIds, setTopicsIds } = props

    const [isLoading, setIsLoading] = useState(false);
    const [newSubTopics, setNewSubTopics] = useState(["", "", "", "", ""]);
    const maxSelection = 12;

    console.log(topics);





    const handleCheckboxChange = (subTopic, id) => {
        const isSelected = details?.selectedSubTopics.includes(subTopic);
        console.log(isSelected);
        if (isSelected) {
            handleChange("selectedSubTopics", details?.selectedSubTopics.filter((i) => i != subTopic));
            setTopicsIds(topicsIds?.filter((i) => i != id))
        } else if (details?.selectedSubTopics.length < maxSelection) {
            handleChange("selectedSubTopics", [...details?.selectedSubTopics, subTopic]);
            setTopicsIds([...topicsIds, id])
        }
    };

    const addCustomSubtopic = (index) => {
        const newTopic = newSubTopics[index]?.trim();
        if (!newTopic) return;



        let tpc = {

            topic_id: "",
            topic_lesson_id: "",
            topic_name: newTopic
        }

        const updated = [...topics];
        updated[index].lessons_topics = [
            tpc,
            ...updated[index].lessons_topics,
        ];
        setTopics(updated);

        const temp = [...newSubTopics];
        temp[index] = "";
        setNewSubTopics(temp);
    };

    return (
        <div
            style={{ backgroundColor: "white" }}
            className="canLisContentWrap"
        >
            <div className="t-wrapper-div p-4">
                <div className="mb-1">
                    <h5 className="ja-1 mainTitleColr">Topics Extracted from Lessons:</h5>
                    <p className="ja-2" style={{ color: "#3a4b68" }}>
                        <strong>Note:</strong> You can select a maximum of 12 Topics.
                    </p>
                </div>

                <div className="did">
                    <p
                        className="ja-2"
                        style={{
                            marginTop: "18px",
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#6b778c",
                        }}
                    >
                        Total Selected: {details?.selectedSubTopics.length}/{maxSelection} Topics
                    </p>

                    {isLoading ? (
                        <>
                            <div>
                                <p className="job_size w-100 text-center">
                                    Sub Topics are generating. Please wait{" "}
                                    <Spinner animation="grow" size="sm" />
                                </p>
                            </div>
                            {/* <KeywordSkeleton /> */}
                        </>
                    ) : (
                        <div className="row gap-1" style={{ marginTop: "10px" }}>
                            {topics.map((subTopicBlock, index) => (
                                <div key={index}>
                                    <div
                                        style={{
                                            border: "1px solid #eceef1",
                                            marginTop: index !== 0 ? "8px" : "0px",
                                            marginBottom: "16px",
                                        }}
                                    ></div>
                                    <h5
                                        style={{
                                            fontSize: "16px",
                                            fontWeight: "500",
                                            marginTop: index !== 0 ? "16px" : "0px",
                                        }}
                                    >
                                        {subTopicBlock?.lessons_name}
                                    </h5>

                                    {/* <div>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                            }}
                                        >
                                            <label
                                                className="jb-4-- form-label-- form-label"
                                                style={{ fontSize: "13px", marginTop: "1px" }}
                                            >
                                                Add Custom Subtopics
                                            </label>
                                        </div>

                                        <div className="d-flex gap-2 mb-2">
                                            {isLoading ? (
                                                <></>
                                            ) : (
                                                <input
                                                    name="Custom Subtopic"
                                                    value={newSubTopics[index] || ""}
                                                    onChange={(e) => {
                                                        const updated = [...newSubTopics];
                                                        updated[index] = e.target.value;
                                                        setNewSubTopics(updated);
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") addCustomSubtopic(index);
                                                    }}
                                                    style={{ width: "30%", height: "37px" }}
                                                    className="w-full rounded-md border border-grey text-black placeholder-white focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 jb-in-1"
                                                />
                                            )}

                                            <div>
                                                <CustomButton
                                                    title="Add"
                                                    handleClick={() => addCustomSubtopic(index)}
                                                    buttonType="tertiory"
                                                />
                                            </div>
                                        </div>
                                    </div> */}

                                    <div className="row">
                                        {subTopicBlock?.lessons_topics?.map((name, subIndex) => {
                                            const id = `subtopic-${index}-${subIndex}-rec`;
                                            return (
                                                <div className="col-md-4" key={subIndex}>
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id={id}
                                                            checked={details?.selectedSubTopics.includes(name?.topic_name)}
                                                            onChange={() => handleCheckboxChange(name?.topic_name, name?.topic_id)}
                                                            disabled={
                                                                details?.selectedSubTopics.length >= maxSelection &&
                                                                !details?.selectedSubTopics.includes(name?.topic_name)
                                                            }
                                                        />
                                                        <label
                                                            style={{ fontSize: "13px" }}
                                                            className="form-check-label"
                                                            htmlFor={id}
                                                        >
                                                            {name?.topic_name}
                                                        </label>
                                                    </div>
                                                </div>
                                            );
                                        })}


                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {!isLoading && (
                    <div className="question-modal-footer d-flex justify-content-end gap-2 mt-2">
                        <CustomButton
                            title="Back"
                            buttonType="secondary"
                            handleClick={() => handleNext(2)}
                        />
                        <CustomButton
                            title="Proceed"
                            handleClick={() => {
                                if (!details?.selectedSubTopics?.length) {
                                    toast.error("Please Select Topics")
                                    return
                                }
                                handleNext(4)
                            }}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}
